function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#f35325;}.cls-2{fill:#81bc06;}.cls-3{fill:#05a6f0;}.cls-4{fill:#ffba08;}.cls-5{fill:#4285f4;}.cls-6{fill:#34a853;}.cls-7{fill:#fbbc04;}.cls-8{fill:#ea4335;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "ico_paymethod_google_ms");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 11,
  y: 11,
  width: 6,
  height: 6
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 18,
  y: 11,
  width: 6,
  height: 6
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 11,
  y: 18,
  width: 6,
  height: 6
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 18,
  y: 18,
  width: 6,
  height: 6
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M12,6.13a6.36,6.36,0,0,0-.11-1.22H6.12V7.23H9.43A2.81,2.81,0,0,1,8.21,9.05v1.5h2A5.84,5.84,0,0,0,12,6.13Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M6.12,12a5.93,5.93,0,0,0,4.06-1.45l-2-1.5a3.78,3.78,0,0,1-2.09.57A3.66,3.66,0,0,1,2.68,7.15h-2V8.69A6.14,6.14,0,0,0,6.12,12Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M2.68,7.15a3.62,3.62,0,0,1,0-2.3V3.3h-2a5.89,5.89,0,0,0,0,5.39Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M6.12,2.37a3.39,3.39,0,0,1,2.35.9h0l1.75-1.71A6,6,0,0,0,6.12,0,6.15,6.15,0,0,0,.65,3.3l2,1.55A3.67,3.67,0,0,1,6.12,2.37Z"
});

var SvgIcoPaymethodGoogleMs = function SvgIcoPaymethodGoogleMs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoPaymethodGoogleMs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_paymethod_google_ms.899f4dd6.svg";
export { ForwardRef as ReactComponent };